'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a throttled function that only invokes `func` at most once per every
 * `wait` milliseconds. The function is invoked at the trailing edge of the
 * `wait`, merging all given args into a new object and chained callback.
 *
 * The function also has two helpers:
 *
 *  - `batched.flush(obj, cb)`
 *  Immediately processes the new args and back pressure.
 *
 *  - `batched.cancel()`
 *  Stops the batched function from invoking, and clears back pressure.
 *
 * @param {function(obj, cb)} fn - The function to wrap.
 * @param {Number} [wait=1] - The milliseconds between the throttled invocation.
 * @returns {function(obj, cb)}
 * @example
 * const fn = (obj, cb) => {
 *   console.log(obj)  // { one: true, two: true }
 *   cb()              // logs two lines: "one", "two"
 * }
 * const batched = batch(fn)
 * batched({ one: true }, () => console.log('one'))
 * batched({ two: true }, () => console.log('two'))
 */
function batch(fn) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var pressure = { obj: [], cbs: [] };
  var throttled = _lodash2.default.throttle(processFn, wait, { leading: false });

  function batchedFn(obj) {
    var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _lodash2.default.noop;

    pushPressure(obj, cb);
    throttled();
  }
  batchedFn.flush = function flushBatched() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _lodash2.default.noop;

    pushPressure(obj, cb);
    processFn();
    throttled.cancel();
  };
  batchedFn.cancel = function cancelBatched() {
    resetPressure();
    throttled.cancel();
  };

  return batchedFn;

  function resetPressure() {
    pressure.cbs = [];
    pressure.obj = [];
  }
  function pushPressure(obj, cb) {
    pressure.obj.push(obj) && pressure.cbs.push(cb);
  }
  function processFn() {
    var cbs = pressure.cbs;
    var obj = _assign2.default.apply(Object, [{}].concat((0, _toConsumableArray3.default)(pressure.obj)));
    var cb = function cb() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return cbs.forEach(function (c) {
        return c.apply(undefined, args);
      });
    };

    resetPressure();
    fn(obj, cb);
  }
}

exports.default = batch;